export default "__VITE_ASSET__YcknastN__$_?url__"